import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../utils/auth';
import { logout } from '../utils/api';

const Header: React.FC = () => {
  const { user, isAdmin, checkAuth } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      // セッション状態を更新
      checkAuth();
      // ホームページにリダイレクト
      window.location.href = '/';
    } catch (error) {
      console.error('ログアウトエラー:', error);
    }
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 h-12">
      <div className="w-full h-full px-4">
        <div className="flex justify-between items-center h-full">
          {/* 左側のロゴ */}
          <div className="flex items-center space-x-4">
            <Link
              to="/"
              className="font-medium text-white text-sm bg-gray-800 px-3 py-1.5 rounded hover:bg-gray-700 transition duration-150"
            >
              JimonGenerator
            </Link>
          </div>

          {/* 右側のログイン情報 */}
          <div className="flex items-center">
            {user ? (
              <div className="flex items-center space-x-3">
                <span className="text-xs text-gray-500">{user.email}</span>
                <button
                  onClick={handleLogout}
                  className="text-xs text-gray-700 hover:text-red-600 hover:bg-red-50 rounded px-2 py-1 transition duration-150"
                >
                  Logout
                </button>
              </div>
            ) : (
              <Link
                to="/login"
                className="text-xs text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded px-2 py-1 transition duration-150"
              >
                Login
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
